import dynamic from 'next/dynamic';

import useUserPublicTokens from '@/utils/hooks/swr/integrations/useUserPublicTokens';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Hooks
import useToggle from '@/utils/hooks/utils/useToggle';

// Components
import Button from '@/components/base/Button';
import H2 from '@/components/base/Headings/H2';
const CreateTokenModal = dynamic(
    () => import('@/components/pages/settings/integrations/Modals/CreateTokenModal')
);

function ApiAccessHeader() {
    const { t } = useTranslation('integrations');
    const { isOpen, toggle } = useToggle();

    const { mutateUserPublicTokens } = useUserPublicTokens({
        options: { revalidateIfStale: false }
    });

    return (
        <div className="flex flex-col space-y-6">
            <div className="flex flex-col justify-between gap-4 sm:flex-row">
                <div className="space-y-m">
                    <H2>{t('api_access.title')}</H2>
                    <p className="font-GMedium text-icoGray-500 dark:text-icoDarkMode-wolf">
                        {t('api_access.description')}
                    </p>
                </div>
                <div>
                    <Button onClick={toggle}>{t('api_access.button_generate_key')}</Button>
                    <CreateTokenModal
                        isOpen={isOpen}
                        toggle={toggle}
                        callbackSuccess={async () => await mutateUserPublicTokens()}
                    />
                </div>
            </div>
        </div>
    );
}

export default ApiAccessHeader;
